import { render, staticRenderFns } from "./ValidationCodeModal.vue?vue&type=template&id=18a325f7&scoped=true&"
import script from "./ValidationCodeModal.vue?vue&type=script&lang=js&"
export * from "./ValidationCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a325f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a325f7')) {
      api.createRecord('18a325f7', component.options)
    } else {
      api.reload('18a325f7', component.options)
    }
    module.hot.accept("./ValidationCodeModal.vue?vue&type=template&id=18a325f7&scoped=true&", function () {
      api.rerender('18a325f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyProfileMobile/ValidationCodeModal.vue"
export default component.exports